import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import './Payment.css';
import apiClient from '../../axios';

function Payment() {
  // State to hold the fetched payment data and wallet information
  const [paymentData, setPaymentData] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get('/bank/withdrawal/history');
        const data = response.data.data;

        // Map transactions from API response
        const paymentHistory = data.PaymentHistory.map((txn, index) => ({
          id: index + 1, // Generate a unique id for each transaction
          withdrawalAmount: txn.withdrawal_amount,
          date: txn.date,
          status: txn.status === 0 ? 'Pending' : 'Completed', // Convert status to string
        }));

        // Set state with the payment history and wallet balance
        setPaymentData(paymentHistory);
        setWalletBalance(data.Userdata[0]?.wallet_amount || 0);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Columns for the data table
  const columns = [
    { name: 'ID', selector: (row) => row.id, sortable: true },
    { name: 'Withdrawal Amount', selector: (row) => `₹${row.withdrawalAmount}`, sortable: true },
    { name: 'Date', selector: (row) => row.date, sortable: true },
    { name: 'Status', selector: (row) => row.status, sortable: true },
  ];

  // Custom styles for the data table
  const customStyles = {
    rows: {
      style: {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  };

  return (
    <div className="container-fluid main_wrapper h-100 p-lg-3 p-md-2 p-sm-2">
      <div className='d-flex justify-content-between mb-5'>
        <h2 className="mb-4">Payment History</h2>
        <div className='wallet-info'>
          <p>Wallet Balance: ₹{walletBalance}</p>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <DataTable
          columns={columns}
          data={paymentData}
          pagination
          highlightOnHover
          customStyles={customStyles}
          paginationPerPage={5}
        />
      )}
    </div>
  );
}

export default Payment;
